import React from 'react';
const TitleStateContext = React.createContext();
const TitleDispatchContext = React.createContext();

function TitleProvider({ children }) {
  const [state, dispatch] = React.useState('');

  return (
    <TitleStateContext.Provider value={state}>
      <TitleDispatchContext.Provider value={dispatch}>{children}</TitleDispatchContext.Provider>
    </TitleStateContext.Provider>
  );
}

function useTitleState() {
  return React.useContext(TitleStateContext);
}
function useTitleDispatch() {
  return React.useContext(TitleDispatchContext);
}

function useTitleProvider() {
  return [useTitleState(), useTitleDispatch()];
}

export { TitleProvider, useTitleState, useTitleDispatch, useTitleProvider };
